<div style="background-color: white;" cdkDropList>
    <div *ngFor="let problem of problems" class="problem-line">
        <mat-divider class="problem-divider"></mat-divider>
        <app-problem-row [record]="problem" [mode]="'compact'" class="problem-row" cdkDrag [cdkDragData]="problem"></app-problem-row>
    </div>
</div>